// extracted by mini-css-extract-plugin
export default {"border-grey":"#EDEFF3","contents":"layout_contents__yPT-H"};